export default __webpack_public_path__ + "static/profile_placeholder-2e0ef81e62c421a7655d3e4e0ece0a48.png";